import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'braid-design-system';
import { LANGUAGES, changeLanguage } from '../i18n';

const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language?.substring(0, 2) || 'en';

    return (
        <Box
            component="select"
            value={currentLang}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                changeLanguage(e.target.value);
            }}
            padding="xxsmall"
            paddingLeft="xsmall"
            paddingRight="xsmall"
            borderRadius="small"
            cursor="pointer"
            aria-label="Select language"
            style={{
                background: 'transparent',
                border: '1px solid rgba(255,255,255,0.3)',
                color: 'inherit',
                fontSize: '12px',
                lineHeight: '1.5',
                minWidth: '60px',
            }}
        >
            {LANGUAGES.map((lang) => (
                <option
                    key={lang.code}
                    value={lang.code}
                    style={{ color: '#000', background: '#fff' }}
                >
                    {lang.nativeLabel}
                </option>
            ))}
        </Box>
    );
};

export default LanguageSwitcher;
